export default theme => ({
  profileMenu: {
    marginTop: 40,
    marginLeft: 20,
  },
  menuPaper: {
    right: "0% !important",
  },
});
